import { Box, Typography, useTheme } from '@mui/material';

interface InfoBannerWidgetProps {
  type: 'warning' | 'info';
  message: string;
  icon?: React.ReactNode;
}

const InfoBannerWidget: React.FC<InfoBannerWidgetProps> = ({ type, message, icon }) => {
  const theme = useTheme();

  const styles = {
    warning: {
      backgroundColor: theme.palette.warning.light,
      borderLeft: `4px solid ${theme.palette.warning.main}`,
      color: theme.palette.warning.dark,
      borderRadius: 0,
    },
    info: {
      backgroundColor: theme.palette.info.light,
      borderRadius: '8px',
      color: theme.palette.info.main,
    },
  };

  return (
    <Box
      sx={{
        ...styles[type],
        padding: { xs: theme.spacing(1), sm: theme.spacing(1) },
        textAlign: 'left',
        width: '100%',
        mt: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: theme.spacing(1),
        }}
      >
        {icon && icon}
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '0.65rem', sm: '0.875rem' },
            fontWeight: 400,
            lineHeight: '1.5',
            color: 'inherit',
            whiteSpace: 'normal',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default InfoBannerWidget;
